var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sceneiframe"},[_c('iframe',{attrs:{"src":("" + _vm.link)}}),_c('bar',{attrs:{"active":-1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }